import React, { type ReactNode } from 'react';

import { AnimatePresence } from 'framer-motion';

import { Layout, TextContainer } from './components';

import { MainWrapper } from './styles';

export interface MainProps {
    children: ReactNode;
}

export function Main({ children }: MainProps) {
    return (
        <MainWrapper>
            <AnimatePresence mode="wait">{children}</AnimatePresence>
        </MainWrapper>
    );
}

Main.Layout = Layout;
Main.TextContainer = TextContainer;
